import React from 'react';
import AsyncComponent from './async';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/campaign/smb"
    path="business/campaign/smb"
    element={<AsyncComponent />}
  />,
];
